<template>
  <div class='Form'>
    <div class="YTitle titel">{{dataValue.title}} <el-button v-if="dataValue.add" class="btn" size="medium" type="primary" round>{{dataValue.btnTitle}}</el-button></div>
    <el-form :disabled='!data.controls.compile'>
      <draggable v-model="controls">
        <div class="from" v-for="(item, index) in controls" :key="item.id">
          <div class="from-title">{{item.type}}：</div>
          <div class="from-item" @click.stop="fromItem(item)" :class="{ styel: item.id === control.id }">
            <i class="el-icon-circle-close close" @click.stop="close(item, index)"></i>
            <div v-if="item.type === 'Title' || item.type === 'TooltipText' || item.type === 'Divider' || item.type === 'Form'">
              <component v-bind:is="item.type" :data='item'></component>
            </div>
            <div class="YFrom" v-else>
              <el-form-item :label="`${item.controls.title}：`" :required='item.controls.required' v-show="item.controls.show">
                <component v-bind:is="item.type" :data='item' @changeControls='changeControls'></component>
              </el-form-item>
            </div>
          </div>
        </div>
      </draggable>
    </el-form>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import deepClone from '@/shared/utils/deep-clone'
export default {
  name: 'Form',

  components: { draggable },

  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {}
  },

  computed: {
    dataValue () { return deepClone(this.data).controls },

    controls: {
      get () { return deepClone(this.data).controls.controlList },
      set (val) {
        const obj = deepClone(this.data)
        obj.controls.controlList = deepClone(val)
        this.setControlWorkOrde(obj)
      }
    },

    control () {
      return this.$store.getters.control
    }
  },

  methods: {
    // 表单控件事件val
    changeControls (val) {
      this.setControl(val)
    },

    // from表单控件关闭事件
    close (item, index) {
      this.controls.splice(index, 1)
      const obj = deepClone(this.data)
      obj.controls.controlList = deepClone(this.controls)
      if (item.id === this.control.id) {
        this.setControl(obj)
      } else {
        this.setControlWorkOrde(obj)
      }
    },

    // from表单控件点击事件
    fromItem (item) {
      if (item.id === this.control.id) return
      this.setControl(item)
    },

    // 向vuex触发setControl方法，改变control，同时改变workOrde
    setControl (val) { this.$store.dispatch('setControl', val) },

    // 向vuex触发setControlWorkOrde方法, 通过control改变workOrde,不改变control
    setControlWorkOrde (val) { this.$store.dispatch('setControlWorkOrde', val) }
  }
}
</script>

<style lang='stylus' scoped>
  .Form
    display flex
    flex-direction column
    .titel
      display flex
      align-items center
      .btn
        margin-left 20px
    .from
      .from-title
        margin-top 20px
      .from-item
        margin-top 10px
        padding 20px
        border 1px solid #dbe3ef
        border-radius 10px
        position relative
        &:hover
          background #ffffff
        .close
          position absolute
          color #dbe3ef
          font-size 20px
          top -1px
          right -1px
          border-radius 50%
          cursor pointer
          &:hover
            color #f56c6c
      .styel
        background #ffffff
</style>
